module.exports = __webpack_public_path__ + "img/Arztbesetzte_Patientenablage.eb00a21d.svg";